import { forwardRef } from 'react';

import styles from './MapHTMLContainer.css';

export const MapHTMLContainer = forwardRef<HTMLDivElement>(function MapHTMLContainer(_, ref) {
  return <div className={styles['map']} data-testid="map.container" ref={ref}></div>;
});
